import { render, staticRenderFns } from "./TheNoticeForm.vue?vue&type=template&id=44c58be6&scoped=true&lang=pug&"
import script from "./TheNoticeForm.vue?vue&type=script&lang=js&"
export * from "./TheNoticeForm.vue?vue&type=script&lang=js&"
import style0 from "./TheNoticeForm.vue?vue&type=style&index=0&id=44c58be6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c58be6",
  null
  
)

export default component.exports